<template>
    <div>
    <router-link v-bind:to="'/categories/' + laptop.category.slug + '-' + laptop.category.id + '/' + laptop.id + '-' + laptop.slug">
        <div class="box">
            <span class="title is-5 has-text-danger " v-if="laptop.old_price_uzs > 0">Распродажа</span>
            <article class="media">
                <div class="columns">
                    <div class="column">
                        <div class="media-left">
                            <figure class="image" v-if="laptop.thumbnail">
                                <img alt="Laptop Image" v-bind:src="laptop.thumbnail"/>
                            </figure>
                            <figure class="image" v-else>
                                <img alt="Laptop Image" v-bind:src="MEDIA_URL + laptop.images[0].url"/>
                            </figure>
                            <div class="separator"></div>
<!--                            <div class="columns">-->
<!--                                <div class="column is-7">-->
                                    <p class="title is-6">{{ laptop.name }}</p>
<!--                                    <p class="subtitle is-7">-->
<!--                                        <span class="tag is-warning">-->
<!--                                            {{laptop.laptop_type.name_singular}}-->
<!--                                        </span>-->
<!--                                    </p>-->
<!--                                </div>-->
<!--                                <div class="column">-->
                            <p class="subtitle is-7">Цена</p>
                                        <span class="title is-7 line-through has-text-grey" v-if="laptop.old_price_uzs > 0">{{ formatPrice(laptop.old_price_uzs) }}</span><br/>
                                        <span class="title is-6" v-if="awaiting === false">{{ formatPrice(laptop.price_uzs) }}</span><br/>
                                        <span class="title is-6" v-if="awaiting === true">Ожидается</span><br/>

<!--                                </div>-->
<!--                            </div>-->
                        </div>
                    </div>
<!--                    <div class="column">-->
<!--                        <div class="media-content">-->
<!--                            <div class="content">-->
<!--&lt;!&ndash;                                <span class="subtitle is-7">Дисплей&ndash;&gt;-->
<!--&lt;!&ndash;                                    <span class="tag">&ndash;&gt;-->
<!--&lt;!&ndash;                                        {{ laptop.screen_size.size }}"&ndash;&gt;-->
<!--&lt;!&ndash;                                        {{ laptop.resolution.name}}&ndash;&gt;-->
<!--&lt;!&ndash;                                        {{ [laptop.resolution.size ]}}&ndash;&gt;-->
<!--&lt;!&ndash;                                    </span>&ndash;&gt;-->
<!--&lt;!&ndash;                                </span><br/>&ndash;&gt;-->
<!--&lt;!&ndash;                                <span class="subtitle is-7">Процессор&ndash;&gt;-->
<!--&lt;!&ndash;                                    <span class="tag">&ndash;&gt;-->
<!--&lt;!&ndash;                                        {{ laptop.processor.brand.name}}&ndash;&gt;-->
<!--&lt;!&ndash;                                        {{ laptop.processor.name}}&ndash;&gt;-->
<!--&lt;!&ndash;                                    </span>&ndash;&gt;-->
<!--&lt;!&ndash;                                </span><br/>&ndash;&gt;-->
<!--&lt;!&ndash;                                <span class="subtitle is-7">Частота&ndash;&gt;-->
<!--&lt;!&ndash;                                    <span class="tag ">&ndash;&gt;-->
<!--&lt;!&ndash;                                        {{ laptop.processor.min_frequency*1000 }}&ndash;&gt;-->
<!--&lt;!&ndash;                                           - &ndash;&gt;-->
<!--&lt;!&ndash;                                        {{ laptop.processor.max_frequency*1000 }}&ndash;&gt;-->
<!--&lt;!&ndash;                                        MГц&ndash;&gt;-->
<!--&lt;!&ndash;                                    </span>&ndash;&gt;-->
<!--&lt;!&ndash;                                </span><br/>&ndash;&gt;-->
<!--&lt;!&ndash;                                <span class="subtitle is-7">Оперативка&ndash;&gt;-->
<!--&lt;!&ndash;                                    <span class="tag ">&ndash;&gt;-->
<!--&lt;!&ndash;                                        {{ laptop.ram}}&ndash;&gt;-->
<!--&lt;!&ndash;                                        ГБ&ndash;&gt;-->
<!--&lt;!&ndash;                                    </span>&ndash;&gt;-->
<!--&lt;!&ndash;                                    <span class="tag ">&ndash;&gt;-->
<!--&lt;!&ndash;                                        {{ laptop.ram_type.generation }}&ndash;&gt;-->
<!--&lt;!&ndash;                                    </span>&ndash;&gt;-->
<!--&lt;!&ndash;                                </span><br/>&ndash;&gt;-->
<!--&lt;!&ndash;                                <span class="subtitle is-7">Память&ndash;&gt;-->
<!--&lt;!&ndash;                                    <span class="tag ">&ndash;&gt;-->
<!--&lt;!&ndash;                                        {{ laptop.main_storage}}&ndash;&gt;-->
<!--&lt;!&ndash;                                        ГБ&ndash;&gt;-->
<!--&lt;!&ndash;                                        {{ laptop.main_storage_type.name}}&ndash;&gt;-->
<!--&lt;!&ndash;                                    </span>&ndash;&gt;-->
<!--&lt;!&ndash;                                    <span class="tag " v-if="laptop.secondary_storage">&ndash;&gt;-->
<!--&lt;!&ndash;                                        {{ laptop.secondary_storage}}&ndash;&gt;-->
<!--&lt;!&ndash;                                        ГБ&ndash;&gt;-->
<!--&lt;!&ndash;                                        {{ laptop.secondary_storage_type.name}}&ndash;&gt;-->
<!--&lt;!&ndash;                                    </span>&ndash;&gt;-->
<!--&lt;!&ndash;                                </span><br/>&ndash;&gt;-->
<!--&lt;!&ndash;                                <span class="subtitle is-7" v-if="laptop.graphics_card">Видеокарта&ndash;&gt;-->
<!--&lt;!&ndash;                                    <span class="tag ">&ndash;&gt;-->
<!--&lt;!&ndash;                                        {{ laptop.graphics_card_memory }} ГБ&ndash;&gt;-->
<!--&lt;!&ndash;                                    </span>&ndash;&gt;-->
<!--&lt;!&ndash;                                    <span class="tag ">&ndash;&gt;-->
<!--&lt;!&ndash;                                        {{ laptop.graphics_card.name}}&ndash;&gt;-->
<!--&lt;!&ndash;                                    </span>&ndash;&gt;-->
<!--&lt;!&ndash;                                </span>&ndash;&gt;-->
<!--&lt;!&ndash;                                <span class="subtitle is-7" v-else-if="laptop.processor.integrated_graphics">Видеокарта&ndash;&gt;-->
<!--&lt;!&ndash;                                    <span class="tag ">&ndash;&gt;-->
<!--&lt;!&ndash;                                        {{ laptop.processor.integrated_graphics}}&ndash;&gt;-->
<!--&lt;!&ndash;                                    </span>&ndash;&gt;-->
<!--&lt;!&ndash;                                </span>&ndash;&gt;-->
<!--&lt;!&ndash;                                <span class="subtitle is-7" v-else>Видеокарта&ndash;&gt;-->
<!--&lt;!&ndash;                                    <span class="tag">&ndash;&gt;-->
<!--&lt;!&ndash;                                        Встроенная&ndash;&gt;-->
<!--&lt;!&ndash;                                    </span>&ndash;&gt;-->
<!--&lt;!&ndash;                                </span><br/>&ndash;&gt;-->
<!--&lt;!&ndash;                                <span class="subtitle is-7">Фишки&ndash;&gt;-->
<!--&lt;!&ndash;                                    <b-tag :key="perk.id" rounded type="is-warning" v-for="perk in laptop.perks">&ndash;&gt;-->
<!--&lt;!&ndash;                                        <small>{{ perk.name}}</small>&ndash;&gt;-->
<!--&lt;!&ndash;                                    </b-tag>&ndash;&gt;-->
<!--&lt;!&ndash;                                </span>&ndash;&gt;-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
            </article>
        </div>
    </router-link>
    </div>
</template>
<script>
    export default {
        name: "ProductCard2",
        props: ['laptop', 'awaiting'],
        inject: ['formatPrice'],
        data() {
            return {
                tagHovered: 'tag' + false,
                MEDIA_URL: process.env.VUE_APP_MEDIA_URL,
            }
        }
    }
</script>
<style scoped>
    .blurred .box {
        opacity: .1;
        transition: .3s;
    }

    .image {
        width: 15rem;
    }

    .separator {
        margin-top: 3rem;
    }

    .tag {
        margin-right: 5px;
        margin-bottom: 5px;
    }

    .box {
        height: 100%;
    }

    .box:hover {
        -webkit-transform: scale(1.02);
        -ms-transform: scale(1.02);
        transform: scale(1.02);
        transition: 0.2s linear;
        /*background-color: #F8F8F8;*/
        /*border: 0.3px solid orange;*/
    }

    .line-through {
        position: relative;
    }

    .line-through:before {
        position: absolute;
        content: "";
        left: 0;
        top: 50%;
        right: 0;
        border-top: 1px solid;
        border-color: inherit;
        color: red;

        -webkit-transform: rotate(-10deg);
        -moz-transform: rotate(-10deg);
        -ms-transform: rotate(-10deg);
        -o-transform: rotate(-10deg);
        transform: rotate(-10deg);
    }
</style>
